/* eslint-disable prefer-destructuring */
import { SafeEnv } from 'SharedDir/utils/helpers';

export const SERVER_API = SafeEnv(() => process.env.API_SERVER);

export const NOTIFICATIONS_SERVER_API = SafeEnv(() => process.env.API_SERVER_NOTIFICATIONS);

export const CENTRIFUGE_URL = SafeEnv(() => process.env.CENTRIFUGE_URL);
